import React from "react";
import PageContainer from "./PageContainer/PageContainer";
import Header from "./atoms/Header";
import { connectionStatusLottieAnimationJson } from "../assets/lottie";
import { useLottie } from "lottie-react";
import { makeStyles } from "@material-ui/core";
import { COLORS } from "../assets/theme";
import useButtonStyles from "../hooks/styles/useButtonStyles";

type Props = {};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "65vh",
    flexDirection: "column",
    position: "relative",
    "& div": {
      marginBottom: 16,
    },
    "& h4": {
      marginTop: 16,
      color: COLORS.gray_2,
      fontWeight: 600,
      fontSize: 14,
    },
    "& p": {
      color: COLORS.black_1,
      fontSize: 12,
    },
  },
  buttonRefreshContainer: {
    padding: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
});

const OfflinePage = (_: Props) => {
  const classes = useStyles();
  const options = React.useMemo(() => {
    let data = {
      animationData: connectionStatusLottieAnimationJson,
      loop: true,
    };
    return data;
  }, []);
  const { View } = useLottie(options, { width: 140, margin: "0 auto" });
  const btnClasses = useButtonStyles();
  function refreshPage() {
    window.location.reload();
  }
  return (
    <PageContainer
      headerNavigationContent={<Header title={"Koneksi"} />}
      withBackground
      mainContainerStyle={{
        padding: "16px 0 72px 0",
        minHeight: "86vh",
      }}
    >
      <div className={classes.container}>
        <div>{View}</div>
        <h4>Tidak ada Koneksi Internet</h4>
        <p>Cek koneksi anda untuk melanjutkan aplikasi.</p>
        <div className={classes.buttonRefreshContainer}>
          <button
            className={[btnClasses.button, "secondary", "full-width"].join(" ")}
            style={{ fontSize: 12 }}
            onClick={refreshPage}
          >
            REFRESH
          </button>
        </div>
      </div>
    </PageContainer>
  );
};

export default OfflinePage;
